import { render, staticRenderFns } from "./exportOrderNumber.vue?vue&type=template&id=6875d73e&scoped=true"
import script from "./exportOrderNumber.vue?vue&type=script&lang=js"
export * from "./exportOrderNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6875d73e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6875d73e')) {
      api.createRecord('6875d73e', component.options)
    } else {
      api.reload('6875d73e', component.options)
    }
    module.hot.accept("./exportOrderNumber.vue?vue&type=template&id=6875d73e&scoped=true", function () {
      api.rerender('6875d73e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Problem/complaintWorkOrder/component/exportOrderNumber.vue"
export default component.exports